export default __webpack_public_path__ + "static/media/email.d14a4945.svg";